import { render, staticRenderFns } from "./CurriculumListNECHeaderPublishButton.vue?vue&type=template&id=0c197fbe&scoped=true&"
import script from "./CurriculumListNECHeaderPublishButton.vue?vue&type=script&lang=ts&"
export * from "./CurriculumListNECHeaderPublishButton.vue?vue&type=script&lang=ts&"
import style0 from "./CurriculumListNECHeaderPublishButton.vue?vue&type=style&index=0&id=0c197fbe&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c197fbe",
  null
  
)

export default component.exports